import { CheckCircle2, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// Comprobante de Venta Rápida (Retail) con reimpresión — presentacional.
export const RetailReceiptDialog = ({ retailReceipt, cerrarComprobanteRetail, imprimirTicketRetail }) => (
  <Dialog open={!!retailReceipt} onOpenChange={(v) => { if (!v) cerrarComprobanteRetail(); }}>
    <DialogContent className="rounded-none border-[#0A0A0A] bg-[#0A0A0A] text-white max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="retail-success-dialog">
      {retailReceipt && (
        <>
          <DialogHeader>
            <DialogTitle className="font-display font-black text-[#10B981] flex items-center gap-2">
              <CheckCircle2 className="h-6 w-6" /> Venta cobrada
            </DialogTitle>
            <DialogDescription className="text-white/60">
              {retailReceipt.items.length} producto(s) · {retailReceipt.metodo}
            </DialogDescription>
          </DialogHeader>
          <div className="border border-white/10 divide-y divide-white/5 max-h-48 overflow-y-auto">
            {retailReceipt.items.map((it, idx) => (
              <div key={it.nombre} className="flex items-center justify-between px-3 py-2 text-sm" data-testid={`retail-receipt-item-${idx}`}>
                <span className="truncate flex-1">{it.cantidad} × {it.nombre}</span>
                <span className="font-mono text-white/70 shrink-0">${(Number(it.precio_unitario) * it.cantidad).toFixed(2)}</span>
              </div>
            ))}
          </div>
          <div className="flex items-center justify-between border-2 border-[#10B981]/50 bg-[#10B981]/10 p-4">
            <span className="text-sm font-bold uppercase tracking-wider text-[#10B981]">Total cobrado</span>
            <span className="font-display font-black text-3xl text-[#10B981]" data-testid="retail-receipt-total">${retailReceipt.total.toFixed(2)}</span>
          </div>
          <div className="grid grid-cols-2 gap-3 mt-2">
            <button onClick={() => imprimirTicketRetail(retailReceipt)} data-testid="retail-reimprimir-btn"
              className="btn-hard h-12 bg-white/5 border border-white/20 hover:border-[#FFCC00] flex items-center justify-center gap-2 font-bold uppercase tracking-wider text-sm">
              <Printer className="h-5 w-5" /> Reimprimir
            </button>
            <button onClick={cerrarComprobanteRetail} data-testid="retail-receipt-cerrar-btn"
              className="btn-hard h-12 bg-[#FFCC00] text-[#0A0A0A] border border-[#FFCC00] flex items-center justify-center gap-2 font-black uppercase tracking-wider text-sm">
              <CheckCircle2 className="h-5 w-5" /> Listo
            </button>
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);

export default RetailReceiptDialog;
